import defaultPosition from "@/helpers/wc/positionSettings";

export const stopPointTimingSettings = {
  title: "Entur API",
  name: "stopPointTimingBase",

  styles: defaultPosition,

  properties: {
    stopPlaceId: "",
    transportLines: [],
    nextDeparture: false,
    css: {
      stopPoint: {
        fontFamily: "Arial",
        fontSize: '30px',
        color: 'white',
        backgroundColor: "rgb(23, 23, 23)"
      },
      caption: {
        fontSize: '46px',
        padding: '30px',
        paddingLeft: '46px',
        color: 'white'
      },
      header: {
        fontSize: 14,
        color: '#aeb7e2',
        borderColor: 'rgb(57, 61, 121)',
        borderWidth: '2px'
      },
      row: {
        height: '46px',
        borderColor: 'rgb(57, 61, 121)',
        borderWidth: '2px'
      },
      time: {
        fontSize: '30px',
      }
    }
  },
  cssLegend: {
    stopPoint: {
      name: 'root',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
    },
    caption: {
      name: 'caption',
      fontSize: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      },
      paddingLeft: {
        type: 'int',
        name: 'paddingLeft',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
    },
    header: {
      name: 'linesHeader',
      color: {
        type: 'color',
        name: 'color'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      borderColor: {
        type: 'color',
        name: 'borderBottom'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      }
    },
    row: {
      name: 'lineItem',
      height: {
        type: 'int',
        name: 'height',
        handler: val => val + 'px'
      },
      borderColor: {
        type: 'color',
        name: 'borderBottom'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      }
    },
    time: {
      name: 'departureTime',
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      }
    }
  }
};
